import type { Transaction } from '@shared/transactions-types';
import { TransactionsContext } from '@shared/transactions-types';

type ProductRouteFactory = (string: string) => string;

const PRODUCT_ROUTES: Record<TransactionsContext, ProductRouteFactory> = {
    ACCOUNT: (routingProductId) => `/accounts/${routingProductId}`,
    CARD: (routingProductId) => `/cards/${routingProductId}`,
    FINANCING: (routingProductId) => `/financing/${routingProductId}`,
};

export const getRouteToProductRoot = (transaction: Transaction): string | undefined => {
    const { ownerAccount } = transaction;

    if (!ownerAccount?.routingProductId) {
        return undefined;
    }

    const productType = ownerAccount.productType ?? TransactionsContext.ACCOUNT;
    return PRODUCT_ROUTES[productType](ownerAccount.routingProductId);
};
